import { useComponentStore } from "@/store";
import {
  FC,
  Children,
  memo,
  cloneElement,
  isValidElement,
} from "react";
import { Props } from "@/models";

const Component: FC<Props.AppFlow> = ({
  children,
  onDone,
  onNext,
  onPrevious,
  currentStepIndex
}) => {
  const { setState, componentSteps } = useComponentStore((state) => state);

  const steps = componentSteps ?? 0;
  const toNextStep = () => {
    setState("componentSteps", steps + 1);
  };

  const toPreviousStep = () => {
    setState("componentSteps", steps - 1);
  };

  const currentChild = Children.toArray(children)[currentStepIndex ?? steps];

  if (isValidElement(currentChild)) {
    return cloneElement(currentChild, {
      onNext: onNext ?? toNextStep,
      onPrevious: onPrevious ?? toPreviousStep,
      onDone,
    } as any);
  }

  return <></>;
};

export const ComponentFlow = memo(Component);
